<script lang="ts" setup>

import ProductFeaturesPopup from "@km/components/productChange/ProductFeaturesPopup.vue";

import {useStore} from "vuex";
import {computed} from "vue";
import gsap from "gsap";
import {
  currentlySelectedFeatures,
  featuresZurAuswahl,
  Produktwechsel
} from "@km/components/productChange/Produktwechsel";

const store = useStore();
const createProduct = () => Produktwechsel.createProduct()
const previewImageSrc = computed(() => store.getters.getProductpreviewPicture);
const changefeature = (data) => Produktwechsel.changeSelectedFeature(data.fo, data.feature);
const isopen = computed(() => store.getters.produktListeFeaturesIsOpen);
const openAnimation = () => gsap.to(".km__modules__productlistfeatures", {duration: 0.4, display: "block"})
const closeAnimation = () => gsap.to(".km__modules__productlistfeatures", {duration: 0.4, display: "none"})


</script>

<template>
  <ProductFeaturesPopup @createproduct="createProduct" :preview_image_src="previewImageSrc"
                        @changefeature="changefeature" :isopen="isopen"
                        :open_animation="openAnimation" :close_animation="closeAnimation"
                        :currently_selected_features="currentlySelectedFeatures"
                        :features_zur_auswahl="featuresZurAuswahl"
  />
</template>

<style scoped lang="scss">

</style>